export default "__VITE_ASSET__5b68cd27__"